import React, { createContext, useContext, useReducer } from 'react';
import { ChildrenProps } from '../common/interfaces/childrenProps';
import { initialState } from './storeApi';
import { reducer } from './reducer';
import { State } from './interfaces';
import { StoreAction } from './action';

interface ContextProps {
  state: State;
  dispatch: ({ type, payload }: StoreAction) => void;
}

const StoreContext = createContext({} as ContextProps);

export const StoreProvider = (props: ChildrenProps): JSX.Element => {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return <StoreContext.Provider value={value}>{children}</StoreContext.Provider>;
};

export const useStore = (): ContextProps => useContext(StoreContext);
